module.exports = __webpack_public_path__ + "img/m-header.8efaa5d3.svg";